import React from "react";
import Navbar from "@/components/site/Navbar";
import HomeHero from "@/components/site/HomeHero";
import TrustTicker from "@/components/site/TrustTicker";
import CompleteDelivery from "@/components/site/CompleteDelivery";
import ServicesOverview from "@/components/site/ServicesOverview";
import AcousticsFeature from "@/components/site/AcousticsFeature";
import SmallJobs from "@/components/site/SmallJobs";
import RecentProjects from "@/components/site/RecentProjects";
import ProjectGallery from "@/components/site/ProjectGallery";
import Accreditations from "@/components/site/Accreditations";
import Refurbishment from "@/components/site/Refurbishment";
import CommercialResidential from "@/components/site/CommercialResidential";
import FreeQuotes from "@/components/site/FreeQuotes";
import Process from "@/components/site/Process";
import WhyUs from "@/components/site/WhyUs";
import ScopeBanner from "@/components/site/ScopeBanner";
import AreasCovered from "@/components/site/AreasCovered";
import QuoteForm from "@/components/site/QuoteForm";
import ContactSection from "@/components/site/ContactSection";
import Faq from "@/components/site/Faq";
import Footer from "@/components/site/Footer";
import MobileStickyCTA from "@/components/site/MobileStickyCTA";

export default function HomePage() {
  return (
    <main data-testid="home-page" className="bg-[#FAF8F4] text-[#2B2420]">
      <Navbar />
      <HomeHero />
      <TrustTicker />
      <ServicesOverview />
      <AcousticsFeature />
      <SmallJobs />
      <RecentProjects />
      <ProjectGallery />
      <Accreditations />
      <CompleteDelivery />
      <Refurbishment />
      <CommercialResidential />
      <FreeQuotes />
      <Process />
      <WhyUs />
      <ScopeBanner />
      <AreasCovered />
      <QuoteForm />
      <ContactSection />
      <Faq />
      <Footer />
      <MobileStickyCTA />
    </main>
  );
}
